import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { RouteLocationNormalized } from 'vue-router'
import { useConfiguration } from './useConfigration'

let appInsights: ApplicationInsights | null = null;

export function useLogs() {

  function getAppInsights(): ApplicationInsights {
    if (appInsights === null) throw new Error("Use 'setup' function before you can 'ApplicationInsights'");
    return appInsights;
  }

  function setup() {
    appInsights = new ApplicationInsights({
      config: {
        connectionString: useConfiguration().APP_INSIGHTS_CONNECTION_STRING,
      }
    });
    appInsights.loadAppInsights();
  }

  function trackPageView(to: RouteLocationNormalized) {
    getAppInsights().trackPageView({
      name: to.name?.toString()
    });
  }

  function trackException(error: Error) {
    getAppInsights().trackException({ exception: error });
  }

  return {
    setup,
    trackPageView,
    trackException
  }
}
